// Single source of truth for what a document status looks like — every
// surface that renders a status (the table cell, its dropdown, bulk status,
// filters, File Details) reads this instead of picking its own color, so
// "Approved" can never be green in one place and blue in another.
//
// `DOCUMENT_STATUS_SEED` (apps/templates_management/list_options.py) marks
// every status value `is_system=True` — this is a fixed enum a company
// cannot extend, unlike Document Type, so the map below is exhaustive and
// the fallback exists only for defensive robustness.
//
// Every value here is one of antd's own named preset colors (never a raw
// hex, never a bare CSS keyword) — `Tag`/`Badge` both resolve a preset name
// to the exact same internal color, which is what actually guarantees
// "Approved" renders identically wherever it's used. Rejected reuses the
// same red ReviewDrawer.tsx's review-outcome pill already uses.
const DOCUMENT_STATUS_COLORS: Record<string, string> = {
  draft: "gold",
  in_review: "blue",
  approved: "green",
  rejected: "red",
  // Not the review pill's `warning`: Badge has no such preset, and its hue is
  // Draft's gold.
  changes_requested: "orange",
  superseded: "purple",
  final: "cyan"
}

const DEFAULT_STATUS_COLOR = "default"

export const documentStatusColor = (
  status: string | null | undefined
): string => (status && DOCUMENT_STATUS_COLORS[status]) || DEFAULT_STATUS_COLOR
